import React from 'react';
import { withTheme } from '@emotion/react';
import { Theme } from '@theme/base';
import { TourTestimonial } from '@model/iceberg';
import { TripTypes } from '@model/common';
import { TourCarousel } from './carousel';

export interface TestimonialsProps {
  testimonials?: Array<TourTestimonial>;
  destinationName: string;
  timeout: number;
  theme?: Theme;
  tripType: TripTypes;
}

export const TourTestimonialsComponent = ({ timeout, testimonials, destinationName, tripType }: TestimonialsProps) => {
  if (!testimonials) {
    return null;
  }
  return (
    <TourCarousel testimonials={testimonials} timeout={timeout} destinationName={destinationName} tripType={tripType} />
  );
};

export const TourTestimonials = withTheme(TourTestimonialsComponent);
